import React, { memo, useState } from 'react';
import classNames from 'classnames';
import styles from './SidebarWrapper.module.scss';
import { Sidebar } from '../Sidebar/Sidebar';
import { FragmentType } from 'client/gql';
import { PermissionCheckerFieldsDocument } from 'hooks/usePermissionChecker';

export const SidebarWrapper = memo(
  ({
    children,
    query,
  }: {
    children: React.ReactNode;
    query: FragmentType<typeof PermissionCheckerFieldsDocument> | undefined;
  }) => {
    const [isFixed, setIsFixed] = useState(false);

    const classes = classNames(styles['sidebar-wrapper'], { [styles.fixed]: isFixed });

    return (
      <div className={classes} data-cy='layoutWrapper'>
        <Sidebar onFixed={setIsFixed} query={query} />
        {children}
      </div>
    );
  },
);
SidebarWrapper.displayName = 'SidebarWrapper';
